@if (!loading) {
<div>
    <mat-button-toggle-group [value]="mode" (valueChange)="setMode($event)">
        <mat-button-toggle value="konsulent">Konsulent</mat-button-toggle>
        <mat-button-toggle value="opgave">Opgave</mat-button-toggle>
    </mat-button-toggle-group>
</div>

<div style="display: flex;gap: 1rem;">
    @if (mode === 'konsulent') {
    <app-autocomplete-chips [formControl]="filterControl" label="Konsulent"
        [displayFn]="consultantsService.displayFn" [valueFn]="consultantsService.valueFn" [options]="consultants"></app-autocomplete-chips>
    } @else {
    <app-autocomplete-chips [formControl]="filterControl" label="Opgave"
        [displayFn]="displayOrder" [valueFn]="orderValue" [options]="orderOptions"></app-autocomplete-chips>
    }

    <mat-form-field appearance="outline" dayMonthYearFormat style="height:75px">
        <mat-label>Periode (DD/MM/YYYY – DD/MM/YYYY)</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Fra" [formControl]="fromControl">
            <input matEndDate placeholder="Til" [formControl]="toControl">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="exportExcel()" [disabled]="!canExport" style="margin-top: 10px;">Eksportér til Excel</button>
    <button mat-raised-button color="primary" (click)="exportPdf()" [disabled]="!canExport" style="margin-top: 10px;">Eksportér til PDF</button>
</div>
}

@if (mode === 'konsulent') {
    @for (group of consultantGroups; track group.consultantId) {
        <app-fee-basis-table mode="konsulent" [identifier]="group.initials" [rows]="group.rows"></app-fee-basis-table>
    }
} @else {
    @for (group of orderGroups; track group.orderId) {
        <app-fee-basis-table mode="opgave" [identifier]="group.taskNumber" [rows]="group.rows"></app-fee-basis-table>
    }
}
